<template>
  <el-checkbox-group
    v-model="booleValue"
    :class="{
      'boole-small' : size === 'small'
    }"
    v-on="$listeners"
    v-bind="{ ...$props }"
    multiple
  >
    <el-checkbox :label="optionValue">{{ optionValue }}</el-checkbox>
  </el-checkbox-group>
</template>

<script>
// TODO 布尔值复选框-不可设置禁用状态
import { booleProps } from '../index.js'

export default {
  props: booleProps,
  data () {
    return {
      booleValue: false
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        const bol = {'false': false, 'true': true}
        this.booleValue = bol[val]
        this.$emit('change', bol[val])
      }
    }
  }
}
</script>
